import React from "react";
import "./WhatsappButton.css";

const WhatsappButton = () => {
  const phoneNumber = "9755357721"; // updated number
  const message = "Hello Shree Ram Car Rental! I'm interested in booking a car. Please provide availability.";

  const handleWhatsApp = () => {
    const url = `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleCall = () => {
    window.location.href = `tel:+91${phoneNumber}`;
  };

  return (
    <div className="floating-contact-container">
      {/* Call Button */}
      <button 
        className="contact-btn call-btn" 
        onClick={handleCall}
        aria-label="Call Us"
      >
        <img 
          src="https://cdn-icons-png.flaticon.com/512/126/126509.png" 
          alt="Call" 
          className="contact-icon"
        />
      </button>

      {/* WhatsApp Button */}
      <button 
        className="contact-btn whatsapp-btn" 
        onClick={handleWhatsApp}
        aria-label="Chat on WhatsApp"
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
          alt="WhatsApp" 
          className="contact-icon"
        />
        <div className="pulse-ring"></div>
      </button>
    </div>
  );
};

export default WhatsappButton;